<template>
  <span
    class="adj-status-badge badge font-weight-bold"
    :class="`badge-${config.variant}`"
    v-b-tooltip.hover.html="tooltipContent || null"
  >
    <i :class="config.icon" class="mr-1"></i>
    {{ config.label }}
    <i v-if="tooltipContent" class="fas fa-info-circle ml-1" style="opacity:0.8"></i>
  </span>
</template>

<script>
import { ADJUSTMENT_DRAFT_STATUS } from '@/utils/enum';

const S = ADJUSTMENT_DRAFT_STATUS;
const STATUS_CONFIG = {
  [S.DRAFT]: { label: 'Nháp', variant: 'secondary', icon: 'fas fa-file-alt' },
  [S.READY_TO_ISSUE]: { label: 'Sẵn sàng phát hành', variant: 'info', icon: 'fas fa-check-circle' },
  [S.ISSUING]: { label: 'Đang phát hành', variant: 'warning', icon: 'fas fa-spinner fa-spin' },
  [S.ISSUED]: { label: 'Đã phát hành', variant: 'success', icon: 'fas fa-check-double' },
  [S.WAITING_PROVIDER]: { label: 'Chờ CQT', variant: 'warning', icon: 'fas fa-clock' },
  [S.ISSUE_FAILED]: { label: 'Lỗi phát hành', variant: 'danger', icon: 'fas fa-times-circle' },
  [S.RETRYING]: { label: 'Đang thử lại', variant: 'warning', icon: 'fas fa-redo' },
  [S.FAST_SYNCING]: { label: 'Đang đồng bộ', variant: 'info', icon: 'fas fa-sync fa-spin' },
  [S.FAST_SYNCED]: { label: 'Đã đồng bộ', variant: 'success', icon: 'fas fa-cloud-upload-alt' },
  [S.FAST_SYNC_FAILED]: { label: 'Lỗi đồng bộ', variant: 'warning', icon: 'fas fa-exclamation-triangle' },
  [S.DELETED]: { label: 'Đã xóa', variant: 'secondary', icon: 'fas fa-trash' },
  [S.CANCELLED]: { label: 'Đã hủy', variant: 'secondary', icon: 'fas fa-ban' },
};

const ERROR_STATUSES = [S.ISSUE_FAILED, S.FAST_SYNC_FAILED, S.WAITING_PROVIDER];

export default {
  name: 'AdjustmentStatusBadge',
  props: {
    status: { type: String, required: true },
    errorMessage: { type: String, default: null },
    errorCode: { type: String, default: null },
  },
  computed: {
    config() {
      return STATUS_CONFIG[this.status] || { label: this.status, variant: 'secondary', icon: 'fas fa-question' };
    },
    tooltipContent() {
      if (!ERROR_STATUSES.includes(this.status)) return null;
      if (!this.errorMessage && !this.errorCode) return null;
      const parts = [];
      if (this.errorCode) parts.push(`<strong>Mã lỗi:</strong> ${this.errorCode}`);
      if (this.errorMessage) parts.push(`<strong>Chi tiết:</strong> ${this.errorMessage}`);
      return parts.join('<br>');
    },
  },
};
</script>

<style lang="scss" scoped>
.adj-status-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.3rem;
  display: inline-flex;
  align-items: center;

  i {
    font-size: inherit;
  }
}
</style>
